import { render, staticRenderFns } from "./companyOchart.vue?vue&type=template&id=d9ff6a8e&scoped=true&"
import script from "./companyOchart.vue?vue&type=script&lang=js&"
export * from "./companyOchart.vue?vue&type=script&lang=js&"
import style0 from "../../statistics/css/companyOchart.css?vue&type=style&index=0&id=d9ff6a8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ff6a8e",
  null
  
)

export default component.exports